import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'contextualMenu.stylesOnMap.device.title' }),
    subtitle: translate({ id: 'contextualMenu.stylesOnMap.device.subTitle' }),
    show: translate({ id: 'contextualMenu.stylesOnMap.device.show' }),
    reduce: translate({ id: 'contextualMenu.stylesOnMap.device.reduce' }),
    hide: translate({ id: 'contextualMenu.stylesOnMap.device.hide' }),
  }))

  return api
}
